/**
 * @packageDocumentation
 * @module HackerAPI.Search.User
 */
import { parseDate } from "../../utils/utils";
/**
 * A data container for data from user searches
 */
var User = /** @class */ (function () {
    /**
     * Creates a new User instance
     * @constructor
     * @param user
     */
    function User(_a) {
        var id = _a.id, name = _a.name, email = _a.email, gender = _a.gender, created_at = _a.created_at, createdAt = _a.createdAt, updated_at = _a.updated_at, updatedAt = _a.updatedAt, school_name = _a.school_name, schoolName = _a.schoolName, school_email = _a.school_email, schoolEmail = _a.schoolEmail;
        /**
         * The user id of the user
         * @type { number }
         */
        this.id = id;
        /**
         * The name of the user
         * @type { string }
         */
        this.name = name;
        /**
         * The email of the user
         * @type { string }
         */
        this.email = email;
        /**
         * The gender of the user
         * @type { string }
         */
        this.gender = gender;
        /**
         * When the user was created in the database
         * @type { Date }
         */
        this.createdAt = parseDate(created_at || createdAt);
        /**
         * When the user was last updated in the database
         * @type { Date }
         */
        this.updatedAt = parseDate(updated_at || updatedAt);
        /**
         * The name of the school that the user attends
         * @type { string }
         */
        this.schoolName = school_name || schoolName;
        /**
         * The school email of the user
         * @type { string }
         */
        this.schoolEmail = school_email || schoolEmail;
    }
    return User;
}());
export default User;
//# sourceMappingURL=user.js.map